<script lang="ts" setup>
import { computed, useSlots } from 'vue';

const props = withDefaults(
  defineProps<{
    title?: string;
    marginBottom?: keyof typeof marginBottomClasses;
    padding?: keyof typeof paddingClasses;
  }>(),
  { marginBottom: 2, padding: 4 }
);

const slot = useSlots();
const hasHeader = computed(() => !!slot.header);

const paddingClasses = {
  0: 'tw-p-0',
  1: 'tw-p-1',
  2: 'tw-p-2',
  3: 'tw-p-3',
  4: 'tw-p-4',
  5: 'tw-p-5',
  6: 'tw-p-6',
  7: 'tw-p-7',
  8: 'tw-p-8'
} as const;

const marginBottomClasses = {
  0: '',
  1: 'tw-mb-1',
  2: 'tw-mb-2',
  3: 'tw-mb-3',
  4: 'tw-mb-4',
  5: 'tw-mb-5',
  6: 'tw-mb-6',
  7: 'tw-mb-7',
  8: 'tw-mb-8'
} as const;
</script>

<template>
  <div
    class="tw-relative tw-block tw-rounded-md tw-border tw-border-solid tw-border-grey-200 tw-bg-white tw-p-0 tw-shadow-none">
    <div
      class="tw-mb-2 tw-border-0 tw-border-b tw-border-solid tw-border-b-grey-200 tw-bg-grey-100 tw-p-4"
      v-if="hasHeader || title">
      <slot name="header">
        <span class="tw-ml-2 tw-font-bold tw-text-primary">{{ title }}</span>
      </slot>
    </div>
    <div :class="[marginBottomClasses[props.marginBottom], paddingClasses[props.padding]]"><slot></slot></div>
  </div>
</template>
